<template>
    <div class="fake-home main-con">
        <template v-if="showDesktop">
            <div class="header-wrapper">
                <div class="con-wrapper hero-wrapper">
                    <main-header></main-header>
                    <div class="banner-wrapper row">
                        <div class="banner-wrapper-inner">
                            <div class="col-xs-12 col-sm-6 align-items-start">
                                <p-register-card ref="register-card"></p-register-card>
                            </div>
                            <div class="col-xs-12 col-sm-6"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="con-wrapper mobile">
                <div class="top-nav-con">
                    <div class="logo-con">
                        <router-link :to="{ name: 'home' }">
                            <img class="img-responsive" :src="`${icdn_url}/desktop-logo.png`" :alt="`Logo ${site_name}`"
                                 v-cloak>
                        </router-link>
                    </div>
                </div>
                <div :class="`button-con ${with_cookie_notice ? 'with-cookie-notice' : ''}`">
                    <!-- <h2>{{ content.mid_section_title ? content.mid_section_title : $t('Find your flirt') }}</h2> -->
                    <div class="button-wrapper">
                        <button class="btn btn-blue" @click="$router.push({ name: 'login' })">{{
                                'Login' | translate
                            }}
                        </button>
                        <button class="btn btn-orange" @click="toRegister">
                            {{ content.registration_box_button ? content.registration_box_button : $t('SEARCH NOW') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <cookies-notice/>
    </div>
</template>

<script>
import MainHeader from '@theme-views/common/MainHeader'
import MainFooter from '@theme-views/common/MainFooter'
import PRegisterCard from '@theme-views/public/partials/PRegisterCard'
import CookiesNotice from '@theme-views/common/CookiesNotice'

export default {
    name: 'fake-home',
    data() {
        return {
            content: window.APP_CONFIG.LANDING_PAGE_CONTENT,
            site_name: window.APP_CONFIG.DOMAIN_NAME,
            icdn_url: window.APP_CONFIG.ICDN_URL,
            cdn_url: window.APP_CONFIG.CDN_URL,
        }
    },
    props: {
        showType: {
            validator: (t) => {
                return ["activation", "complete_register", "boost_profile", "claim_daily_icebreakers"].includes(t)
            },
            default: null
        }
    },
    methods: {
        loadPage() {
            if (this.showType === "activation") {
                this.$root.$children[0].changeModalContent({
                    name: 'activate-pop-up',
                    alignCenter: true,
                    hasCloseButton: true,
                    canCloseBackDrop: false,
                    extraClasses: 'mobile-dark',
                    props: {
                        hasCloseButton: false,
                        title: 'Finish your profile',
                        msg: 'Welcome! As your profile is new, we will give maximum visibility once you complete it.'
                    }
                })
                this.$root.$children[0].$emit('open-modal');
                return;
            }
            if (this.showType === "complete_register") {
                this.$root.$children[0].changeModalContent({
                    name: 'completed-register-pop-up',
                    alignCenter: true,
                    hasCloseButton: false,
                    canCloseBackDrop: false,
                    extraClasses: 'mobile-dark',
                })
                this.$root.$children[0].$emit('open-modal');
                return;
            }
            if (this.showType === "boost_profile") {
                this.$root.$children[0].changeModalContent({
                    name: 'boosted-profile-pop-up',
                    alignCenter: true,
                    hasCloseButton: false,
                    canCloseBackDrop: false,
                    extraClasses: 'mobile-dark',
                })
                this.$root.$children[0].$emit('open-modal');
                return;
            }

            if (this.showType === "claim_daily_icebreakers") {
                this.$root.$children[0].changeModalContent({
                    name: 'claimed-daily-free-icebreakers-pop-up',
                    alignCenter: true,
                    hasCloseButton: false,
                    canCloseBackDrop: false,
                    extraClasses: 'mobile-dark',
                })
                this.$root.$children[0].$emit('open-modal');
                return;
            }
        },
        toRegister() {
            this.$root.$children[0].changeModalContent({
                name: 'p-register-pop-up',
                hasCloseButton: false,
                alignCenter: true,
                canCloseBackDrop: true,
                extraClasses: "mobile-dark centered",
                mobileBreakpoint: 1199,
            })
            this.$root.$children[0].openModal()
        },
    },
    computed: {
        showDesktop() {
            return this.$root.$children[0].width > 1199
        },
        with_cookie_notice() {
            return !window.APP_CONFIG.COOKIE_POPUP && !this.$store.getters['cookies/isConsentApproved']
        }
    },
    mounted() {
        this.loadPage()
    },
    components: {
        MainHeader,
        MainFooter,
        PRegisterCard,
        CookiesNotice
    }
}
</script>

<style lang="scss">
.fake-home {
    &.main-con {
        height: 100%;
        > .header-wrapper {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: 100% 100%;
            background-color: #fff;
            position: relative;
            z-index: 2;

            background-image: var(--img-bg-transparent-o);
            background-color: var(--poly-primary);
            background-size: cover;
            background-position: top;

            .hero-wrapper {
                margin: 0;
                width: 100%;
                position: relative;
                background-image: var(--img-person-banner);
                background-repeat: no-repeat;
                background-size: auto 90%;
                max-width: 1440px;
                margin: 0 auto;
                background-position: 800px bottom;
                @media screen and (min-height: 1000px) {
                    background-position: 100%;
                }
                @media (max-width: 1300px) {
                    background-position: 650px bottom;
                }
            }
            > .con-wrapper {
                display: flex;
                flex-direction: column;
                position: relative;
                z-index: 2;
                padding: 0;
                min-height: 100vh;
                max-height: 100vh;
            }
        }
        .banner-wrapper {
            padding: 38px 0 155px;
            margin-left: -10px;
            margin-right: -10px;
            height: calc(100vh - 106px);
            @media screen and (min-height: 1301px) {
                height: auto;
            }
            > div[class*="col-"] {
                display: flex;
                align-items: center;
            }

            &-inner {
                width: 1170px;
                margin: 0 auto;
                position: relative;
                z-index: 2;
                display: flex;
                align-items: center;
            }
        }
        .p-register-card {
            min-height: 200px;
            width: 100%;
            padding: 0;
            h1 {
                font-size: $xlg;
                @include font-settings(normal, normal, normal, 1, normal);
                color: #312929;
                margin: 0;
                margin-bottom: 15px;
                &.title {
                  font-weight: 600;
                }
            }
            input, select { min-height: 50px !important; }
            p.sub-title {
                margin: 0;
                font-size: $normal-md;
                color: #797979;
                font-family: $font-secondary;
                @include font-settings(normal, normal, normal, 36px, 400);
            }
        }
    }
    @media(max-width: 1199px) {
        &.main-con {
            > .con-wrapper {
              height: 100%;
                .top-nav-con {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    padding: 18px 20px;
                    z-index: 22;
                    position: relative;
                    .logo-con {
                        width: 140px;
                        display: flex;
                        justify-content: center;
                        > a {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                }

                .button-con {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: center;
                    padding: 0 24px 20px;
                    min-height: 345px;
                    min-height: calc( 100% - 60px );
                    &.with-cookie-notice {
                        padding-bottom: 70px;
                    }
                    > h2 {
                        font-family: $font-primary;
                        font-size: $small-lg;
                        @include font-settings(normal, normal, normal, 40px, 600);
                        margin-bottom: 40px;
                    }
                    .button-wrapper {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        max-width: 500px;
                        width: 100%;
                        > .btn {
                            width: 100%;
                            margin: 0 0 20px;
                            padding: 14px;
                            &.btn-google-oauth,
                            &.btn-yahoo-oauth,
                            &.btn-apple-oauth,
                            &.btn-microsoft-oauth {
                                margin-bottom: 0;
                                padding: 16px;
                                font-size: 14px;
                                line-height: 1;
                            }
                        }
                        p.limit {
                            margin: 10px 0 18px;
                            text-align: center;
                            color: #ffff;
                            font-family: $font-secondary;
                            font-size: 14px;
                            @include font-settings(normal, normal, normal, normal, 700);
                            text-transform: lowercase;
                        }
                    }
                }
            }
        }
    }
}
</style>
